import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'statcode': {
    title: '单据状态',
    type: 'select',
    equation: city,
    dictionary: 'A0055'
  }
}

export default {
  'invupl_id': {
    title: '单据号',
    type: 'input',
    equation: all,
    slot: true,
    width: 140
  },
  'sellername': {
    title: '开票方',
    type: 'dialog',
    equation: be,
    dialog: {
      component: 'ClientSelect',
      title: '开票方'
    },
    width: 200
  },
  'customername': {
    title: '订单客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'invoice': {
    title: '发票号码',
    type: 'input',
    equation: all
  },
  'inv_type': {
    describe: true,
    title: '发票类型',
    type: 'select',
    equation: city,
    dictionary: 'A0032'
  },
  'status': {
    title: '单据状态'
  },
  'apdate': {
    title: '审批日期',
    type: 'date',
    equation: all
  },
  'apuser': {
    title: '审批人',
    type: 'input',
    equation: all
  },
  'product_id': {
    title: '产品编码',
    type: 'input',
    equation: all,
    width: 200
  },
  'product_text': {
    title: '产品名称',
    type: 'input',
    equation: all,
    width: 400
  },
  'quantity': {
    title: '数量(瓶)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'price': {
    title: '含税单价(元/瓶)',
    width: 140,
    xlsxFmt: {
      t: 'n'
    }
  },
  'amount': {
    title: '含税总价(元)',
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/dealer-manage/config/invoiceQuery.js